import { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import useScrollListener from '../../hooks/useScrollListener'; 

import HomeHeader from '../../components/home-header/home-header.component';
import MultiImagesDisplay from '../../components/multi-images-display/multi-images-display.component';
import ContentBox from '../../components/content-box/content-box.component';

import MidBanner from '../../components/mid-banner/mid-banner.component';

import TextAndImage from '../../components/text-and-image/text-and-image.component';

import ContactFormBox from '../../components/contact-box/contact-box.component';

import txtimage1 from '../../jpeg/pages/free-audit/22a.jpg';
import txtimage2 from '../../jpeg/pages/free-audit/2.jpg';


import Footer from '../../components/footer/footer.component';

import bgImage from '../../jpeg/pages/home/1a.jpg';
import { HomePageContainer } from './mywebpage.styles';

const MyWebpage = ({ onScroll }) => {
	const contentRef = useScrollListener(onScroll);
	const contactRef = useRef(null); // Ref for Contact section

	const scrollToContact = () => {
		// Smoothly scroll to the Contact section
		if (contactRef.current) {
			contactRef.current.scrollIntoView({ behavior: 'smooth' });
		}
	};

	// Check for scroll flag in sessionStorage on load
	useEffect(() => {
		if (sessionStorage.getItem('scrollToContact') === 'true') {
			scrollToContact();
			sessionStorage.removeItem('scrollToContact'); // Reset the flag after scrolling
		}
	}, []);

	const textAndImage1 = {
		img: txtimage1,
		title: "Ready to See What’s Possible?",
		text: "Unlock the insights your store needs to reach new heights in growth, sales, and performance. No strings attached, no cost — just actionable information designed to help you succeed.",
		title2: "Actionable Recommendations",
		text2: "We provide clear, next steps that you can implement immediately.",
	};

	const textAndImage2 = {
		img: txtimage2,
		title: "Personalized Approach",
		text: "Every store is different. Our audit addresses your unique challenges and goals.",
		title2: "Data-Driven Insights",
		text2: "We use a combination of industry standards and our expertise to give you a practical, results-focused analysis.",
		txtL: true,
	};

	const multiDisplay1 = [{
		img: txtimage1,
		title: 'SOCIAL MEDIA SHOP',
		subtitle: 'Embrace the power of social media commerce and unlock a world of possibilities for your brand.',
		link: '../company/contactus' 
	},
	{
		img: txtimage1,
		title: 'ECOMMERCE STORE',
		subtitle: 'Elevate your online presence with a custom ecommerce website designed specifically for your business.',
		link: '../company/contactus' 
	},
	{
		img: txtimage1,
		title: 'MARKETPLACE',
		subtitle: 'Own a large-scale online platform where people and businesses can buy and sell.',
		link: '../company/contactus' 
	}];


	const contentBox = {
		title: "NOBODY'S GOT YOU LIKE TREE DOES",
		// title: "YOU DONT NEED NO OTHER BODY",
		text: 'FROM COMPREHENSIVE NICHE ANALYSIS TO EXPERT STORE DEVELOPMENT, OPTIMIZATION, AND VIRTUAL ASSISTANCE, WE PROVIDE END-TO-END SOLUTIONS FOR YOUR ECOMMERCE SUCCESS.',
		buttonLink: '../company/contactus',
		buttonText: 'REACH OUT TO US'
	};

	return (
		<HomePageContainer ref={contentRef}>
			<div className='home-scroll'>
				<HomeHeader
					title="Is Your Store Set Up to Thrive? Don’t Guess, Know Where You Stand Today." 
					btnText="Get Audit"
					bgImage={bgImage}
					whatToDO={scrollToContact} 
				/>

				<MultiImagesDisplay 
					displays={multiDisplay1}
				/>

				

				<ContentBox 
					title={contentBox.title} 
					text={contentBox.text}
					whatToDo={scrollToContact} 
					buttonLink={contentBox.buttonLink}
					buttonText={contentBox.buttonText}
				/>
				
				<MidBanner 
					title={contentBox.title} 
					text={contentBox.text}
					whatToDo={scrollToContact} 
					buttonLink={contentBox.buttonLink}
					buttonText={contentBox.buttonText}
				/>

				<div className='text-and-image-box'>
					<TextAndImage 
						img={textAndImage1.img} 
						title={textAndImage1.title} 
						text={textAndImage1.text}
						title2={textAndImage1.title2} 
						text2={textAndImage1.text2}
						txtL={textAndImage1.txtL}
					/>
					<TextAndImage 
						img={textAndImage1.img} 
						title={textAndImage1.title} 
						text={textAndImage1.text}
						title2={textAndImage1.title2} 
						text2={textAndImage1.text2}
						txtL={textAndImage1.txtL}
					/>
					
					{/* <TextAndImage 
						img={textAndImage2.img} 
						title={textAndImage2.title} 
						text={textAndImage2.text}
						title2={textAndImage2.title2} 
						text2={textAndImage2.text2}
						txtL={textAndImage2.txtL}
					/> */}
				</div>

				<div ref={contactRef}>
					<ContactFormBox whatContactForm={<div class="klaviyo-form-U4SYUJ"></div>} />
				</div>
				
			</div>

			<span style={{
				width: '100%',
				display: 'flex',
				justifyContent: 'flex-end',
				
			}}>
				<Link 
					style={{
						marginRight: '3%',
						position: 'fixed',
						bottom: '10%',
						zIndex: 1000
					}}
					to='../launch-store'
					// onClick={toMail}
				>
					{/* <Button
						style={{
							fontSize: 'clamp(1rem, 2vw, 1.3rem)',
							fontWeight: 'bold',
							minWidth: 'max-content',
							height: 'max-content',
							backgroundColor: 'white',
							color: 'black',
						}}
						>
						<bold>Launch a New Store</bold>
					</Button> */}
				</Link>
			</span>

			<Footer />
		</HomePageContainer>
	);
}

export default MyWebpage;
